import { Flex, Typography } from 'antd';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import MobileWarningOverlayStyles, { IconCircle } from './styles';
import useDeviceDetection from '../../hooks/useDeviceDetection';

const MobileIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H7V6h10v10z" />
  </svg>
);

const LaptopIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z" />
  </svg>
);

const ArrowIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
  </svg>
);

const MobileWarningOverlay = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { isMobile, isTablet, deviceType } = useDeviceDetection();

  if (!isMobile && !isTablet) {
    return null;
  }

  const getTitle = () => {
    if (deviceType === 'mobile') {
      return t('mobileWarning.mobileNotSupported');
    } else if (deviceType === 'tablet') {
      return t('mobileWarning.tabletNotSupported');
    }
    return t('mobileWarning.switchToDesktop');
  };

  const getDescription = () => {
    if (deviceType === 'mobile') {
      return t('mobileWarning.mobileDescription');
    } else if (deviceType === 'tablet') {
      return t('mobileWarning.tabletDescription');
    }
    return t('mobileWarning.defaultDescription');
  };

  const overlayContent = (
    <MobileWarningOverlayStyles>
      <Flex
        vertical
        gap={32}
        align="center"
        justify="center"
        className="content-wrapper"
      >
        <Flex gap={16} align="center" justify="center">
          <IconCircle
            $bgColor={theme.colors.redPrimary}
            $textColor={theme.colors.light}
          >
            <MobileIcon />
          </IconCircle>
          <ArrowIcon />
          <IconCircle
            $bgColor={theme.colors.bluePrimary}
            $textColor={theme.colors.light}
          >
            <LaptopIcon />
          </IconCircle>
        </Flex>

        <Typography.Title level={1} className="title">
          {getTitle()}
        </Typography.Title>

        <Typography.Text className="description">
          {getDescription()}
        </Typography.Text>

        <div className="card-container">
          <div className="card-content">{t('mobileWarning.cardContent')}</div>
        </div>
      </Flex>
    </MobileWarningOverlayStyles>
  );

  return createPortal(overlayContent, document.body);
};

export default MobileWarningOverlay;
